<template>
    <div>
        <el-form-item label="Alt"
                      :error="errors[addLanguageSuffix('alt')]">
            <el-input type="textarea"
                      v-model="form[addLanguageSuffix('alt')]"
                      placeholder="Alt">
            </el-input>
        </el-form-item>
        <el-form-item label="Grafika desktop (1160px szerokości)"
                      :error="errors['desktop_image']">
            <image-input-component v-model="form.desktop_image"></image-input-component>
        </el-form-item>
        <el-form-item label="Mapa desktop"
                      :error="errors['desktop_map']">
            <el-input v-model="form.desktop_map" type="textarea"
                      :placeholder="mapPlaceholder"/>
        </el-form-item>
        <el-form-item label="Grafika tablet (max 1160px szerokości)"
                      :error="errors['tablet_image']">
            <image-input-component v-model="form.tablet_image"></image-input-component>
        </el-form-item>

        <el-form-item label="Mapa desktop"
                      :error="errors['tablet_map']">
            <el-input v-model="form.tablet_map" type="textarea"
                      :placeholder="mapPlaceholder"/>
        </el-form-item>
        <el-form-item label="Grafika mobile (max 768px)"
                      :error="errors['mobile_image']">
            <image-input-component v-model="form.mobile_image"></image-input-component>
        </el-form-item>
        <el-form-item label="Mapa desktop"
                      :error="errors['mobile_map']">
            <el-input v-model="form.mobile_map" type="textarea"
                      :placeholder="mapPlaceholder"/>
        </el-form-item>
    </div>
</template>
<script>
    export default {
        props: ['form', 'errors'],
        data () {
            return {
                "mapPlaceholder": '<area alt="" title="VISA" href="https://visa.com" shape="rect" coords="1025, 314, 1166, 469" />'
            }
        }
    }
</script>
<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// LogotypesWidget.vue?751356af